export const ROUTES = {
  HOME: 'home',
  LOGIN: 'login',
  OAUTH_CONTINUE: 'oauthContinue',

  LOGOUT: 'logout',
  ACCEPTINVITATION: 'acceptInvitation',
  ACCEPT_ORGANIZATION_INVITATION: 'acceptOrganizationInvitation',
  ACCEPT_PROJECT_HANDOFF: 'acceptProjectHandoff',
  FORGOTPASSWORD: 'forgot-password',
  RESETPASSWORD: 'reset-password',
  REGISTER: 'register',
  AGENCY_SIGNUP: 'agency-signup',
  SETUPBLANKUSER: 'setupBlankUser',
  DASHBOARD_INDEX: 'dashboardIndex',
  DASHBOARD: 'dashboard',
  DASHBOARD_AUDIENCE: 'dashboardAudience',
  DASHBOARD_WEBSITE: 'dashboardWebsite',
  DASHBOARD_CONVERSIONS: 'dashboardConversions',
  REVENUE: 'revenue',
  PEOPLE: 'people',
  VISITOR_DETAIL: 'visitorDetail',
  LEAD_ALERTS: 'leadAlerts',
  ADS: 'ads',
  INTEGRATIONS: 'integrations',
  INTEGRATION: 'integration',
  TEMPLATES: 'templates',
  TEMPLATE: 'template',
  ANNOUNCEMENTS: 'announcements',
  USERS: 'users',
  USER: 'user',
  METRICS: 'metrics',
  SETTINGS: 'settings',
  ACCOUNT: 'account',
  CREATECAMPLAIGNWITHINDASHBOARD: 'createCampaignWithinDashboard',
  CAMPAIGNS: 'campaigns',
  CREATECAMPAIGN: 'createCampaign',
  CAMPAIGN: 'campaign',
  CAMPAIGN_EDITOR: 'campaignEditor',
  EMAILS: 'emails',
  EMAIL: 'email',
  GOAL: 'goal',
  GOALS: 'goals',
  CREATEGOAL: 'createGoal',
  EDITGOAL: 'editGoal',
  SEGMENTGROUPSPARENT: 'segmentGroupsParent',
  SEGMENTGROUPS: 'segmentGroups',
  SEGMENTGROUPTEMPLATES: 'segmentGroupTemplates',
  QUESTIONS: 'questions',
  SEGMENTGROUP: 'segmentGroup',
  SEGMENTGROUPCREATE: 'segmentGroupCreate',
  QUESTION: 'question',
  QUESTIONCREATE: 'questionCreate',
  CREATESEGMENTGROUPWITHINDASHBOARD: 'createSegmentGroupWithinDashboard',
  WIDGET: 'widget',
  CREATEWIDGET: 'widgetCreate',
  WIDGETOFFERFUNNEL: 'widget:offerFunnel',
  WIDGETOFFERFUNNELOFFER: 'widget:offerFunnel:offer',
  WIDGETOFFERFUNNELSEGMENTGROUP: 'widget:offerFunnel:segmentGroup',
  WIDGETOFFER: 'widget:offer',
  OFFERFUNNELWIDGET: 'offerFunnel:widget',
  OFFERFUNNELOFFER: 'offerFunnel:offer',
  OFFERFUNNELSEGMENTGROUP: 'offerFunnel:segmentGroup',
  FORMS: 'forms',
  OFFERS: 'offers',
  OFFER: 'offer',
  FORM: 'form',
  CREATEOFFER: 'offerCreate',
  CREATEFORM: 'formCreate',
  OFFERFUNNELS: 'offerFunnels',
  OFFERFUNNEL: 'offerFunnel',
  CREATEOFFERFUNNEL: 'offerFunnelCreate',
  OFFERFUNNELNODE: 'offerFunnelNode',
  WIDGETS: 'widgets',
  PAGES: 'pages',
  PAGE_NEW: 'pageNew',
  PAGE_EDITOR: 'pageEditor',
  INSIGHTS: 'insights',
  NOTFOUND: 'NotFound',
  NOTFOUNDAUTH: 'NotFoundAuth',
  ONBOARDING: 'onboarding',
  UPGRADE: 'upgrade',
  SPLIT_TESTS: 'splitTests',
  REVIEW_SESSION: 'reviewSession',
  SETTINGS_GENERAL: 'settingsGeneral',
  SETTINGS_WEBSITE: 'settingsWebsite',
  SETTINGS_PAGE_DOMAINS: 'settingsPageDomains',
  SETTINGS_FORMS: 'settingsForms',
  SETTINGS_PRIVACY: 'settingsPrivacy',
  SETTINGS_AI: 'settingsAi',
  SETTINGS_COLLABORATORS: 'settingsCollaborators',
  SETTINGS_BILLING: 'settingsBilling',
  ACCOUNT_PROFILE: 'accountProfile',
  ACCOUNT_SECURITY: 'accountSecurity',
  ACCOUNT_NOTIFICATIONS: 'accountNotifications',
  ACCOUNT_PREFERENCES: 'accountPreferences',
  ACCOUNT_PROJECTS: 'accountProjects',
  ACCOUNT_API: 'accountApi',
  ACCOUNT_BILLING: 'accountBilling',
  ACCOUNT_AFFILIATE: 'accountAffiliate',
  ACCOUNT_ORGANIZATIONS: 'accountOrganizations',
  ACCOUNT_ORGANIZATION: 'accountOrganization',
  AGENCY_PROFILE: 'agencyProfile',
  AGENCY_CLIENTS: 'agencyClients',
  GROWTH_IDEAS: 'growthIdeas',
  OPTIMIZATIONS: 'optimizations',
  RESPONSES: 'responses'
}
